import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  placeholder: {
    color: '#000000',
  },
}));
